import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { isDefined } from '@sama/js-core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { RootFocusedAnnotationService } from '../../../../../../../core/outputs/annotation/annotation-shared/utils/root-focused-annotation.service';
import { AnnotationState } from '../../../../../../../cross-team-shared/annotation/shared/state/annotation-state';
import { strictValues } from '../../../../../../../cross-team-shared/misc-utils/strict-record';
import { Attribute } from '../../../../../../../team-apis/otterdam/taxonomy';
import { AvailableAttributeService } from '../../../../utils/available-attribute.service';

@Component({
  selector: 'h3-tag-pane',
  templateUrl: './tag-pane.component.html',
  styleUrls: ['./tag-pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TagPaneComponent extends DirectiveSuperclass implements OnInit {
  focusedAnnotationAttributes$!: Observable<Attribute[]>;
  focusedAnnotationStore$!: Observable<Store<AnnotationState>>;

  private rootFocusedAnnotationService = inject(RootFocusedAnnotationService);
  private availableAttributeService = inject(AvailableAttributeService);

  ngOnInit() {
    this.focusedAnnotationStore$ = this.rootFocusedAnnotationService
      .getAnnotationStore$()
      .pipe(filter(isDefined));
    this.focusedAnnotationAttributes$ = this.getFocusedAnnotationAttributes$();
  }

  private getFocusedAnnotationAttributes$() {
    return this.focusedAnnotationStore$.pipe(
      switchMap((annotationStore) =>
        this.availableAttributeService.getAnnotationAttributes$(
          annotationStore,
        ),
      ),
      map((attributes) => strictValues(attributes ?? {})),
    );
  }
}
